import { useSelector } from "react-redux";
import { Form } from "react-bootstrap";

import { table_tabs, div_title, first, last } from "../../maintainers.module.scss";

const UsersNotifications = ({ data, setData }) => {
	const { notifications } = useSelector((state) => state.maintainers_users);

	const handleChangeSelected = (e, i) => {
		let new_notifications = [...data.notifications];

		const isEquals = (element) => Number(element) === Number(notifications[i].id);
		const index_user_role = data.notifications.findIndex(isEquals);

		if (e.target.checked) {
			if (index_user_role === -1) {
				new_notifications.push(notifications[i].id);
			}
		} else {
			if (index_user_role !== -1) {
				new_notifications.splice(index_user_role, 1);
			}
		}

		setData({ ...data, notifications: new_notifications });
	};

	return (
		<table className={table_tabs} border="0" cellSpacing="0" cellPadding="0">
			<thead>
				<tr>
					<th style={{ width: "15%" }}>
						<div className={`${div_title} ${first}`}>#</div>
					</th>
					<th>
						<div className={`${div_title} ${last}`}>Notificación</div>
					</th>
				</tr>
			</thead>
			<tbody>
				{notifications.map((notification, i) => {
					return (
						<tr key={i}>
							<td style={{ textAlign: "center" }}>
								<Form.Check
									type="switch"
									id={`switch_notification_${i}`}
									checked={data && data.notifications && data.notifications.includes(Number(notification.id)) ? true : false}
									onChange={(e) => handleChangeSelected(e, i)}
								/>
							</td>
							<td>{notification.description}</td>
						</tr>
					);
				})}
			</tbody>
		</table>
	);
};

export default UsersNotifications;
